// extracted by mini-css-extract-plugin
module.exports = {"trustedRetailerBanner":"Ek-z","trustedRetailerTooltipWrapper":"Fk-z"};